export default __webpack_public_path__ + "static/media/arrow.46f56c6b.svg";